
import { Reporting } from '../../api/reports/reporting';
import AuthToken from '../../api/auth/Auth';
import { formatDate, parseDate } from '../../api/dates/date_formatter';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      rangeType: 'created',
      startDate: '',
      startDateFormatted: '',
      endDate: '',
      endDateFormatted: '',
    };
  },
  methods: {
    parseDateInternal(date: string): string {
      return parseDate(date);
    },
    runReport() {
      Reporting.getTeeTimeReport(this.startDate, this.endDate, this.rangeType);
    },
  },
  watch: {
    startDate() {
      this.startDateFormatted = formatDate(this.startDate);
    },
    endDate() {
      this.endDateFormatted = formatDate(this.endDate);
    },
  },
});
